/**
 * Design tokens — keep in sync with DESIGN.md and styles/tokens.css
 */
export const colors = {
  primary: '#0ABAB5',
  primaryHover: '#099A9A',
  primaryDeep: '#088F8A',
  mint: '#B3DFDE',
  cream: '#f9f7f2',
  sectionLight: '#e8f5f5',
  footer: '#0e3331',
  ink: '#1a2e2c',
  body: '#333333',
  muted: '#555555',
  open: '#0a8f4a',
  closed: '#b0483f',
  star: '#fbbf24',
  surface: '#ffffff',
  border: '#d4d4d4',
  borderSoft: '#e5e5e5',
  disabled: '#cccccc',
} as const;

export const colorRgb = {
  primary: '10, 186, 181',
  mint: '179, 223, 222',
  footer: '14, 51, 49',
} as const;

export const rgba = (
  channel: keyof typeof colorRgb,
  alpha: number
): string => `rgba(${colorRgb[channel]}, ${alpha})`;

export const radii = {
  sm: '8px',
  md: '12px',
  lg: '16px',
  pill: '999px',
} as const;
